import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetEps from './met-eps';
import MetEpsDetail from './met-eps-detail';
import MetEpsUpdate from './met-eps-update';
import MetEpsDeleteDialog from './met-eps-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetEpsUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetEpsUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetEpsDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetEps} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetEpsDeleteDialog} />
  </>
);

export default Routes;
